import { ValueType } from 'realgrid'

export const noticeFields = [
    {
      fieldName: 'msgNo',
      dataType: ValueType.TEXT
    },
    {
      fieldName: 'msgTitle',
      dataType: ValueType.TEXT
    },
    {
      fieldName: 'msgCreator',
      dataType: ValueType.TEXT
    },
    {
      fieldName: 'msgStartDt',
      dataType: ValueType.TEXT
    }
  ]
  
  export const noticeColumns = [
    {
      name: 'msgNo',
      fieldName: 'msgNo',
      type: 'data',
      width: '30',
      styleName: "rg-align-center",
      header: '공지번호',
      visible: true,
      editable: false
    },
    {
      name: 'msgTitle',
      fieldName: 'msgTitle',
      type: 'data',
      width: '200',
      styleName: "rg-align-left",
      header: '제목',
      visible: true,
      editable: false
    },
    {
      name: 'msgCreator',
      fieldName: 'msgCreator',
      type: 'data',
      width: '60',
      styleName: "rg-align-center",
      header: {
        text: '생성자',
      },
      visible: true,
      editable: false
    },
    {
      name: 'msgStartDt',
      fieldName: 'msgStartDt',
      type: 'data',
      width: '80',
      styleName: "rg-align-center",
      header: {
        text: '생성일',
        showTooltip: false
      },
      visible: true,
      editable: false
    }
  ]